<script>
  import {tick, onMount, createEventDispatcher} from 'svelte'

  import Section1 from './linear/LinearSection1.svelte'
  import Section2 from './linear/LinearSection2.svelte'
  import Section3 from './linear/LinearSection3.svelte'
  import Section4 from './linear/LinearSection4.svelte'
  import Section5 from './linear/LinearSection5.svelte'
  import Section6 from './linear/LinearSection6.svelte'
  import Section7 from './linear/LinearSection7.svelte'
  import Section8 from './linear/LinearSection8.svelte'
  import Section9 from './linear/LinearSection9.svelte'
  import EndSection from './EndSection.svelte'

  const dispatch = createEventDispatcher()

  onMount(async () => {
    await tick()
    dispatch('mounted', {path: 'linear'})
  })
</script>

<Section1 />
<Section2 />
<Section3 />
<Section4 />
<Section5
  title="The end of runaround. Your direct buys, all in <span class='nowrap'>one place.</span>"
  subtitle="We have access to all the premium television content that you are used to buying. Access the TV networks and OTT platforms that you negotiated in the Upfront."
  />
<Section6 />
<Section7 />
<Section8 />
<Section9 />
<EndSection on:path />